import { z } from 'zod';

import { FEATURE_KEYS, type FeatureKey } from '../features';

/** A asserção do tuplo precisa ser `FeatureKey` (não `string`), senão o zod infere `string` solto. */
export const FeatureKeyEnum = z.enum(FEATURE_KEYS as [FeatureKey, ...FeatureKey[]]);

export type FeatureCatalogoItemOutput = {
  key: FeatureKeyEnumType;
  nome: string;
  descricao: string;
};

export const FeatureToggleInput = z.object({
  habilitada: z.boolean(),
});

export type FeatureKeyEnumType = z.infer<typeof FeatureKeyEnum>;
export type FeatureCatalogoItemOutputType = FeatureCatalogoItemOutput;
export type FeatureToggleInputType = z.infer<typeof FeatureToggleInput>;
